import { apiBaseURL, authActionType, toastifyType, Tokens } from "../../../constant";
import { setLoading } from "../loadingAction";
import apiConfig from '../../../config/apiConfig';
import { addTost } from "../toastAction";
import { environment } from "../../../config/environment";

export const login = (user) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await apiConfig.post(apiBaseURL.ADMIN_LOGIN, user);
    if (response?.data?.success) {
      localStorage.setItem(Tokens.ADMIN_TOKEN, (response?.data?.data?.token));
      localStorage.setItem(Tokens.ADMIN, JSON.stringify(response?.data?.data?.user));
      localStorage.setItem(Tokens.ADMIN_ROLE, (response?.data?.data?.user?.role));
      dispatch({ type: authActionType.LOGIN_ADMIN, payload: response?.data?.data });
      dispatch(addTost({ type: toastifyType.SHOW_SUCCESS_MESSAGE, message: response.data.message }));
    }
    dispatch(setLoading(false));
    // Redirect to a different page after successful login
    const userInfo = localStorage.getItem(Tokens.ADMIN);
    const UserData = JSON.parse(userInfo);
    if (UserData?.role === 'user') {
      window.location.href = environment.BASE_URL + "/curves";
    } else {
      window.location.href = environment.BASE_URL + "/admin/ycr";
    }
  } catch (error) {
    dispatch(setLoading(false));
    dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }));
    console.error('error', error);
  }
};


export const logout = (navigate) => async (dispatch) => {
  // await apiConfig.post(apiBaseURL.USER_LOGIN).then((response) => {
  // const response = await apiConfig.get(apiBaseURL.LOGOUT);
  localStorage.removeItem(Tokens.ADMIN_TOKEN)
  localStorage.removeItem(Tokens.ADMIN)
  localStorage.removeItem(Tokens.ADMIN_ROLE);
  localStorage.clear()

  // dispatch({ type: authActionType.LOGOUT, payload: response.data.data });
  // dispatch(setLoading(false))
  await navigate('/login')
};
